import React from 'react'
import PropTypes from 'prop-types'
import Alert from '@mui/material/Alert'
import './SplashScreen.scss'

export default function WidthAlert({ top }) {
  return (
    <Alert
      severity="warning"
      sx={{
        mb: 2,
        width: '35vw',
        position: 'absolute',
        top,
        left: '35%',
        zIndex: 1050,
        '& .MuiAlert-message': {
          alignSelf: 'center'
        }
      }}
      className="width-alert"
    >
      Remove segments or adjust the width of the street in the drop down above
      to accomodate all the segments.
    </Alert>
  )
}

WidthAlert.propTypes = {
  top: PropTypes.number
}
